import type {
  NewsProductsResponse,
  ProductCategorysResponse,
  ProductDetail,
  ProductListRequestRaw,
  ProductListResponse,
} from "@features/shopping/types";

import { api } from "@services/api";
import { decryptData, encryptData } from "@shared/utils/encryption";

export class ProductService {
  private readonly basePath = "/public/product";

  // Get news products
  public async getNewsProducts(): Promise<NewsProductsResponse> {
    const response = await api.post<{ data: string }>("/public/news", {
      data: await encryptData({}),
    });

    return await decryptData<NewsProductsResponse>(response.data);
  }

  // Get products categories
  public async getProductCategories(countryCode?: string): Promise<ProductCategorysResponse> {
    const response = await api.post<{ data: string }>(`${this.basePath}/category`, {
      data: await encryptData({
        ...(countryCode ? { country_code: countryCode } : {}),
        is_effect: true,
      }),
    });

    return await decryptData<ProductCategorysResponse>(response.data);
  }

  // Get product details
  public async getProductDetails(
    productId: number,
    countryCode?: string,
    memberId?: string,
  ): Promise<ProductDetail> {
    const response = await api.post<{ data: string }>(`${this.basePath}/detail`, {
      data: await encryptData({
        ...(countryCode ? { country_code: countryCode } : {}),
        product_id: productId.toString(),
        ...(memberId ? { member_id: memberId } : {}),
      }),
    });

    return await decryptData<ProductDetail>(response.data);
  }

  // Get products
  public async getProducts({
    countryCode,
    memberId,
    productCatId,
  }: ProductListRequestRaw): Promise<ProductListResponse> {
    const requestBody = {
      ...(productCatId !== undefined ? { product_cat_id: productCatId.toString() } : {}),
      ...(countryCode ? { country_code: countryCode } : {}),
      ...(memberId ? { member_id: memberId } : {}),
    };

    const response = await api.post<{ data: string }>(`${this.basePath}`, {
      data: await encryptData(requestBody),
    });

    return await decryptData<ProductListResponse>(response.data);
  }
}

export const productService = new ProductService();
